import { useMutation } from "@tanstack/react-query";

import { UseMutationProps } from "../types";
import { mutations } from "./factories";

export const useStartBookingFlowMutation = (
  props?: UseMutationProps<typeof mutations.start>,
) => {
  return useMutation({
    mutationFn: mutations.start,
    ...props,
  });
};

export const useUpdateBookingFlowMutation = (
  props?: UseMutationProps<typeof mutations.update>,
) => {
  return useMutation({
    mutationFn: mutations.update,
    ...props,
  });
};

export const useStoreSlotDateViewMutation = (
  props?: UseMutationProps<typeof mutations.storeSlotDateView>,
) => {
  return useMutation({
    mutationFn: mutations.storeSlotDateView,
    retry: false,
    ...props,
  });
};
